import React from 'react';
import BienvenidoForm from '../components/BienvenidoForm'
import TeamsSection from '../components/TeamsSection';
import WorkerCard from '../components/WorkerCard';
import TeamCard from '../components/TeamCard';
import ChartSection from '../components/ChartSection';
import ProductosTable from '../components/ProductosTableForm';
import OrganismoCard from '../components/OrganismoCard';
import InventarioResumen from '../components/InventarioForm';
import { storageService } from '../service/storage';

const Dashboard = () => {

  const storage = storageService.getSettings();
  console.log("Storage cambios : ",storage)

  return (
    <div className="dashboard">
      {storage.dailySec && <BienvenidoForm />}
      
      {storage.workersSec &&
        <TeamsSection 
          sectionName="Personal"
          cardType="worker"
          renderCard={(worker) => <WorkerCard worker={worker}  />}
        />
      }

      {storage.organismosSec &&
        <TeamsSection 
          sectionName="Organismos"
          cardType="organismo"
          renderCard={(organismo) => <OrganismoCard organismo={organismo}/>}
        />
      }

      {storage.hourGraphSec && <ChartSection />}

      {(storage.topVentasSec || storage.topRecepSec) && <ProductosTable showTopVentas = {storage.topVentasSec} showTopRecepcionados = {storage.topRecepSec}/>}
      
      {/* Sección de Gráfico */}
      {storage.resumeInventorySec && <InventarioResumen/>}

      {storage.teamSec &&
        <TeamsSection 
          sectionName="Equipos de Ventas"
          cardType="team"
          renderCard={(team) => <TeamCard team={team} />}
        />
      }
      
    </div>
  );
};

export default Dashboard;